import React from 'react';
import Link from 'gatsby-link';

import s from './index.module.css';

import content from '../content/home.js';

class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: ''
    };

    this.index = 0;
    this.done = '';
  }

  componentDidMount() {
    setTimeout(() => {
      this.showText(200);
    }, 1500);
  }

  showText(interval) {
    if (this.index < content.length) {
      this.done += content[this.index++];
      this.setState({ content: this.done });

      setTimeout(() => {
        const delay = (content[this.index + 1] === "\n") ? Math.random() * 2000 : Math.random() * 100;
        this.showText(delay);
      }, interval);
    }
  }

  render() {
    return (
      <div>
        <pre className={s.content}>{this.state.content}</pre>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js